import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VProgressCircular,{directives:[{name:"show",rawName:"v-show",value:(_vm.isloading),expression:"isloading"}],class:{ 'absolute-een-spinner': _vm.absolute, 'een-spinner': true },attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }